import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { useAuth } from './context/AuthContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AuthCallback from './pages/AuthCallback';
import Profile from './pages/Profile';
import UserManagement from './pages/UserManagement';
import NotFound from './pages/NotFound';
import Settings from './pages/settings/Settings';
import POS from './pages/settings/POS';
import EmailTemplates from './pages/settings/EmailTemplates';
import PostLoginLoader from './components/PostLoginLoader';

// Components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';


function App() {
  const { isAuthenticated, loading } = useAuth();
  const isAuthCallback =
    typeof window !== 'undefined' && window.location.pathname === '/auth/callback';

  if (loading && !isAuthCallback) {
    return <PostLoginLoader />;
  }

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth={false} disableGutters>
        <Routes>
          {/* Public routes */}
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} />
          <Route path="/register" element={!isAuthenticated ? <Register /> : <Navigate to="/dashboard" />} />
          <Route path="/forgot-password" element={!isAuthenticated ? <ForgotPassword /> : <Navigate to="/dashboard" />} />
          <Route path="/reset-password" element={!isAuthenticated ? <ResetPassword /> : <Navigate to="/dashboard" />} />
          
          {/* Protected routes */}
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="profile" element={<Profile />} />
            <Route path="users" element={<AdminRoute><UserManagement /></AdminRoute>} />

            {/* Settings Nested Routes */}
            <Route path="settings" element={<Settings />}>
              <Route path="pos" element={<POS />} />
              <Route path="email-templates" element={<EmailTemplates />} />
            </Route>
          </Route>
          
          {/* Not found route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Container>
    </ThemeProvider>
  );
}

export default App;
